import { api } from './api'

/**
 * Build the URL for a document PDF endpoint, optionally requesting a specific locale.
 *
 * @param type  Document type key, e.g. 'regulamin', 'polityka_prywatnosci'
 * @param lang  BCP-47 language tag, e.g. 'pl', 'en', 'cs'. When omitted the
 *              server will resolve the locale from the Accept-Language header.
 */
export function documentPdfUrl(type: string, lang?: string): string {
  const base = `${api.defaults.baseURL}/documents/${type}/pdf`
  if (lang) {
    return `${base}?lang=${encodeURIComponent(lang)}`
  }
  return base
}
